import { createElement as h } from 'react';
import { createSystem, load } from 'uinix-ui';

import { icons } from '../tokens/icons';
import { config } from './config';
import { styles } from './styles';
import { theme } from './theme';

const system = createSystem({
  icons,
  styles,
  theme,
});

export const initialize = () => load({ config, h, system });
